import getConfig from 'next/config';

import { getServerSideSitemap } from 'next-sitemap';

import { DateUtil } from '../client/utils/date';

const { BASE_URL } = getConfig().publicRuntimeConfig;

export const getServerSideProps = async (ctx) => {
  const lastModified = DateUtil.toUtcOffsetString(new Date());

  const fields = [
    {
      loc: `${BASE_URL}/`,
      lastmod: lastModified,
    },
    {
      loc: `${BASE_URL}/tentang/`,
      lastmod: lastModified,
    },
    {
      loc: `${BASE_URL}/pusat-bantuan/`,
      lastmod: lastModified,
    },
    {
      loc: `${BASE_URL}/ketentuan/`,
      lastmod: lastModified,
    },
    {
      loc: `${BASE_URL}/cara-beli/`,
      lastmod: lastModified,
    },
    {
      loc: `${BASE_URL}/privasi/`,
      lastmod: lastModified,
    },
    {
      loc: `${BASE_URL}/media/`,
      lastmod: lastModified,
    },
    {
      loc: `${BASE_URL}/produk/`,
      lastmod: lastModified,
    },
  ];

  return getServerSideSitemap(ctx, fields);
};

// Default export to prevent next.js errors
export default () => { };